import React, { useState } from 'react';
import { TableSchema } from '../pages/App';

interface Props {
  tables: TableSchema[];
  current: TableSchema | null;
  onSelect: (t: TableSchema) => void;
}

const Sidebar: React.FC<Props> = ({ tables, current, onSelect }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      className={
        (collapsed ? 'w-12' : 'w-56') +
        ' flex flex-col border-r border-slate-200 bg-white shadow-sm transition-all'
      }
    >
      <header className="flex items-center justify-between px-4 py-3">
        {!collapsed && (
          <span className="text-sm font-semibold uppercase tracking-wide text-slate-500">
            Таблицы
          </span>
        )}
        <button
          className="ml-auto rounded-full border border-slate-200 p-1 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? 'Развернуть сайдбар' : 'Свернуть сайдбар'}
          title={collapsed ? 'Развернуть' : 'Свернуть'}
        >
          <span className="text-lg leading-none">{collapsed ? '›' : '‹'}</span>
        </button>
      </header>
      {!collapsed && (
        <ul className="list-none m-0 flex-1 space-y-1 px-2 pb-4">
          {tables.map(t => (
            <li
              key={t.name}
              className={`cursor-pointer rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition ${
                current?.name === t.name
                  ? 'bg-indigo-50 text-indigo-700 shadow-sm'
                  : 'hover:bg-slate-100'
              }`}
              onClick={() => onSelect(t)}
            >
              {t.label || t.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Sidebar;
